module.exports = "<i class=\"{{getIcon()}}\"\r\n   (click)=\"showAttachment()\">\r\n\r\n</i>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/view-attachment-file/view-attachment-file.component.html
// module id = 2337
// module chunks = 66